"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudCryptV3SessionError = exports.CloudCryptV3Error = void 0;
exports.isUserHasUnconfirmedOperationError = isUserHasUnconfirmedOperationError;
var errors_1 = require("../../common/errors");
var CloudCryptV3Error = /** @class */ (function (_super) {
    __extends(CloudCryptV3Error, _super);
    function CloudCryptV3Error(status, message) {
        var _this = _super.call(this, message) || this;
        _this.status = status;
        _this.name = "CloudCryptV3Error";
        Object.setPrototypeOf(_this, CloudCryptV3Error.prototype); // Для чего это: https://github.com/Microsoft/TypeScript/wiki/FAQ#why-doesnt-extending-built-ins-like-error-array-and-map-work
        return _this;
    }
    return CloudCryptV3Error;
}(Error));
exports.CloudCryptV3Error = CloudCryptV3Error;
var CloudCryptV3SessionError = /** @class */ (function (_super) {
    __extends(CloudCryptV3SessionError, _super);
    function CloudCryptV3SessionError(status, message) {
        var _this = _super.call(this, message) || this;
        _this.status = status;
        _this.name = "CloudCryptV3SessionError";
        Object.setPrototypeOf(_this, CloudCryptV3SessionError.prototype); // Для чего это: https://github.com/Microsoft/TypeScript/wiki/FAQ#why-doesnt-extending-built-ins-like-error-array-and-map-work
        return _this;
    }
    return CloudCryptV3SessionError;
}(Error));
exports.CloudCryptV3SessionError = CloudCryptV3SessionError;
function isUserHasUnconfirmedOperationError(e) {
    return (e instanceof errors_1.CommonError &&
        e.code === errors_1.ErrorCodes.DssUserHasUnconfirmedOperation);
}
